// extracted by mini-css-extract-plugin
module.exports = {"summaryDesktopMain":"CheckoutSummary_summaryDesktopMain__cb5_Z"};